// extracted by mini-css-extract-plugin
export default {"UserHeader":"Index_UserHeader__1xp0C","BtnMenu":"Index_BtnMenu__8yBmt","LayoutHolder":"Index_LayoutHolder__hGL6M","PageContent":"Index_PageContent__JJTr7"};